<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <div class="d-flex justify-content-between">
            <h4 slot="header" class="card-title">
              Tipos de marcas
              <TotalRegisters :total="brandsTypeTableData.total" totalText="tipos de marcas" />
            </h4>

            <div class="d-flex align-items-center">
              <button class="btn btn-info btn-sm" @click="visibilityStates.create = true">
                Adicionar Tipo de Marca
              </button>
            </div>
          </div>

          <Table :tableData="brandsTypeTableData" :data="brandTypes" :columns="['id', 'name', 'answer', 'createdAt', 'updatedAt', 'actions']" :actions="['edit']" @pagechanged="onPageChange" @openEditModal="openEditModal"> </Table>

          <ListLoader v-if="brandsTypeTableData.loading" :height="40" :amount="8"></ListLoader>
          <Error v-if="!brandsTypeTableData.loading && brandsTypeTableData.error"></Error>
          <Empty v-if="!brandsTypeTableData.loading && !brandsTypeTableData.error && brandTypes.length === 0"></Empty>
        </card>
      </div>
    </div>

    <!-- Modal Edit -->
    <Modal v-model="visibilityStates.edit" action="Salvar" title="Editar Item" @closeModal="visibilityStates.edit = false" @confirmAction="updateBrandType(brandType)">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" hidden class="form-control" v-model="brandType.id" />
          <input type="text" class="form-control" v-model="brandType.name" />
        </div>
        <div class="form-group">
          <label>Pergunta</label>
          <input type="text" class="form-control" v-model="brandType.answer" />
        </div>
      </template>
    </Modal>

    <!-- Modal Add -->
    <Modal v-model="visibilityStates.create" :error="createError" action="Salvar" title="Adicionar novo Tipo de Marca" @closeModal="clear(), (visibilityStates.create = false)" @confirmAction="createBrandType(newBrandType)">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="newBrandType.name" placeholder="Ex: Pergunta de zero a dez" />
        </div>

        <div class="form-group">
          <label>Pergunta</label>
          <input type="text" class="form-control" v-model="newBrandType.answer" placeholder="Ex: Você recomendaria {brandTitle}?" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Empty from '@/components/Common/Empty';
import Modal from '@/components/Modal/Modal';
import Table from '@/components/Common/Table';
import TotalRegisters from '@/components/Common/TotalRegisters';

export default {
  components: {
    Empty,
    Modal,
    Table,
    TotalRegisters,
  },
  data() {
    return {
      temporaryImage: null,
      visibilityStates: {
        create: false,
        edit: false,
      },
      newBrandType: {
        name: '',
        answer: '',
      },
    };
  },
  computed: {
    brandTypes() {
      return this.$store.getters['brandTypes/getBrandsTypes'];
    },
    brandsTypeTableData() {
      return this.$store.getters['brandTypes/getBrandsTypeTableData'];
    },
    brandType() {
      return this.$store.getters['brandTypes/getBrandType'];
    },
    createError() {
      return this.$store.getters['brandTypes/getCreateError'];
    },
  },
  methods: {
    createBrandType: async function(payload) {
      await this.$store.dispatch('brandTypes/create', payload);

      if (this.createError === '') {
        this.visibilityStates.create = false;
        this.clear();
      }
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    onPageChange(page) {
      this.$store.dispatch('brandTypes/setPage', page);
    },
    clear() {
      Object.assign(this.$data.newBrandType, this.$options.data().newBrandType);
    },
    openEditModal: async function(id) {
      await this.$store.dispatch('brandTypes/getBrandTypeById', id);
      this.visibilityStates.edit = true;
    },
    updateBrandType: async function(params) {
      let payload = {
        id: params.id,
        params: {
          name: params.name,
          answer: params.answer,
        },
      };
      await this.$store.dispatch('brandTypes/update', payload);
      this.visibilityStates.edit = false;
    },
  },
  mounted() {
    this.$store.dispatch('brandTypes/resetPagination');
  },
};
</script>
